'use client';

import { Suspense } from "react";
import { useFormattedName, useFormattedNameDummy } from "../hooks/useName";
import type { DesiredNameFormat, FallbackNameFormat } from "../utils/name-utils";

export function FormattedName({desiredFormat, fallbackFormat}: {readonly desiredFormat: DesiredNameFormat, readonly fallbackFormat: FallbackNameFormat}) {
	const dummy = useFormattedNameDummy(desiredFormat, fallbackFormat);
	return <Suspense fallback={dummy}>
		<FormattedNameNeedsSuspending desiredFormat={desiredFormat} fallbackFormat={fallbackFormat} />
	</Suspense>;
}


export function FormattedNameNeedsSuspending({desiredFormat, fallbackFormat}: {readonly desiredFormat: DesiredNameFormat, readonly fallbackFormat: FallbackNameFormat}) {
	return useFormattedName(desiredFormat, fallbackFormat);
}
